import { useQuery } from "@tanstack/react-query";
import { httpService } from "../../services/httpService";
import { API_CONFIG } from "../../shared/constants";
import { ICampaignData } from "../../features/Campaigns/interface";

interface ICampaignsResponse {
  results: ICampaignData[];
  total: number;
  page: number;
  per_page: number;
}

export const useCampaigns = () => {
  return useQuery<ICampaignsResponse, Error>({
    queryKey: ["campaigns"],
    queryFn: async () => {
      const response = await httpService.get<ICampaignsResponse>(
        API_CONFIG.path.campaigns,
        {
          page: 1,
          per_page: 999999999,
        }
      );
      return response;
    },
  });
};
